import About from './about/About';
import Home from './home/Home';
import Services from './services/Services';
import Contacts from './contacts/Contacts';
import NewsContainer from './news/News';
import EventsContainer from './events/Events';
import General from './general/index';
import Login from './login/Login';
import Logout from './logout/Logout';

export { About, Home, Contacts, Services, NewsContainer, EventsContainer, Login, General, Logout };



// WEBPACK FOOTER //
// ./src/containers/index.js